// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + "main" + "." + "6f33a84e0e0c35ba8d90" + ".css";
};